"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Logo_1 = __importDefault(require("../Logo"));
var __1 = require("..");
var Typography_1 = require("../Typography/Typography");
var DesktopMenu_1 = __importDefault(require("./Components/DesktopMenu"));
var Header_styles_1 = require("./Header-styles");
var Header = function (_a) {
    var backgroundImage = _a.backgroundImage, _b = _a.backgroundOpacity, backgroundOpacity = _b === void 0 ? 1.0 : _b, breadcrumb = _a.breadcrumb, children = _a.children, className = _a.className, content = _a.content, logoLink = _a.logoLink, onLogoLinkClick = _a.onLogoLinkClick, mainMenu = _a.mainMenu, _c = _a.maxWidth, maxWidth = _c === void 0 ? 960 : _c, mobileHeaderLeft = _a.mobileHeaderLeft, onMainMenuChange = _a.onMainMenuChange, _d = _a.solidBackground, solidBackground = _d === void 0 ? true : _d, subHeader = _a.subHeader, title = _a.title;
    var isMobile = (0, __1.useIsMobile)();
    var LogoElem = React.useCallback(function () { return (React.createElement(Header_styles_1.StyledLogo, { href: logoLink ? logoLink : '#', onClick: onLogoLinkClick },
        React.createElement(Logo_1.default, { size: 58, variant: 'tele2-b2b-white' }))); }, [logoLink, onLogoLinkClick]);
    var hasText = Boolean(breadcrumb || title);
    var hasContent = Boolean(hasText || content);
    return (React.createElement("div", null,
        React.createElement(Header_styles_1.TopBar, { className: className },
            React.createElement(Header_styles_1.TopBarBackground, { "$solid": solidBackground }),
            React.createElement(Header_styles_1.TopBarContent, { isMobile: isMobile },
                React.createElement(Header_styles_1.TopBarContentLeft, null, isMobile ? React.createElement(React.Fragment, null, mobileHeaderLeft) : React.createElement(LogoElem, null)),
                React.createElement(Header_styles_1.TopBarContentCenter, null, isMobile ? React.createElement(LogoElem, null) : React.createElement(DesktopMenu_1.default, { mainMenu: mainMenu, onMainMenuChange: onMainMenuChange })),
                React.createElement(Header_styles_1.TopBarContentRight, null, children))),
        React.createElement(Header_styles_1.HeaderWrapper, { "$image": backgroundImage, "$mobile": isMobile, "$opacity": backgroundOpacity }, hasContent && (React.createElement(Header_styles_1.HeaderContent, null,
            hasText && (React.createElement(React.Fragment, null,
                !backgroundImage && React.createElement(Header_styles_1.HeaderCrumbs, null, breadcrumb),
                React.createElement(Header_styles_1.HeaderTitle, { "$maxWidth": maxWidth }, backgroundImage ? (React.createElement(Typography_1.BigTitle, { color: "BRAND_WHITE" }, title)) : (React.createElement(Typography_1.H1, { color: "BRAND_WHITE" }, title))))),
            content))),
        subHeader && React.createElement(Header_styles_1.SubHeader, null, subHeader)));
};
exports.default = Header;
